import { render, staticRenderFns } from "./authorization-back.vue?vue&type=template&id=f808589c&scoped=true&"
import script from "./authorization-back.vue?vue&type=script&lang=js&"
export * from "./authorization-back.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f808589c",
  null
  
)

export default component.exports